import { Children, type ReactNode } from 'react';

const TRAILING_ARROW = /\s*([→↓])\s*$/;

/**
 * Hides a trailing "→" or "↓" from assistive technology. The glyph stays on
 * screen, but a screen reader would otherwise say "rightwards arrow" after
 * every link name.
 */
export function arrowSafe(children: ReactNode): ReactNode {
  const parts = Children.toArray(children);
  const last = parts[parts.length - 1];
  if (typeof last !== 'string') return children;
  const m = TRAILING_ARROW.exec(last);
  if (!m) return children;
  return [
    ...parts.slice(0, -1),
    last.slice(0, m.index),
    // A margin, not a space: spaces collapse inside flex links such as buttons.
    <span key="arrow" aria-hidden="true" className="ml-[0.28em]">{m[1]}</span>,
  ];
}
